import { render } from "./5m_step_two.vue?vue&type=template&id=126cf883&scoped=true"
import script from "./5m_step_two.vue?vue&type=script&lang=js"
export * from "./5m_step_two.vue?vue&type=script&lang=js"

import "./5m_step_two.vue?vue&type=style&index=0&id=126cf883&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126cf883"]])

export default __exports__